import axios from 'axios';
import Cookies from 'js-cookie';
import { BASE_URL } from '@/helpers/apiUtilities.js';
import alerts from '../helpers/storeModuleHelpers/alerts';

export const state = {
  userToken: null,
  savingPassword: false,
  loading: false,
  packages: [],
  programs: [],
  ...alerts.getState([
    'login',
    'products'
  ])
};

export const mutations = {
  ...alerts.mutations,
  setUserToken: function (state, token) {
    state.userToken = token;

    if (token) {
      const in30Minutes = 1 / 48;
      Cookies.set('user-token', token, {
        expires: in30Minutes
      });
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
      Cookies.remove('user-token');
      delete axios.defaults.headers.common.Authorization;
    }
  },
  setSavingPassword: function (state, bool) {
    state.savingPassword = bool;
  },
  setLoading: function (state, bool) {
    state.loading = bool;
  },
  setProducts: function (state, organization) {
    state.programs = organization?.programs || [];
    state.packages = organization?.packages || [];
  }
};

export const actions = {
  validateUser: function (store, { code, token }) {
    store.commit('clearAlerts', 'login');

    if (token) {
      store.commit('setUserToken', token);
      return true;
    }

    return axios.post(BASE_URL + '/LifeOmic/Token', { code })
      .then(response => {
        const token = response?.data?.token;
        store.commit('setUserToken', token);
        return true;
      })
      .catch((error) => {
        store.commit('setUserToken', null);
        if (error?.response?.status === 401) {
          const alert = {
            alertGroup: 'login',
            status: 'error',
            message: 'Not valid authorization.'
          };
          store.commit('addAlert', alert);
        } else {
          const alert = {
            alertGroup: 'login',
            status: 'error',
            message: 'Error logging in:',
            error
          };
          store.commit('addAlert', alert);
        }
        return false;
      });
  },
  login: function (store, auth) {
    store.commit('clearAlerts', 'login');
    return axios.post(BASE_URL + '/AuthenticateUser', {}, { auth })
      .then(response => {
        const token = response?.data?.token;
        store.commit('setUserToken', token);
        store.dispatch('loadUser');
        return true;
      })
      .catch((error) => {
        store.commit('setUserToken', null);
        if (error?.response?.status === 401) {
          const alert = {
            alertGroup: 'login',
            status: 'error',
            message: 'Incorrect email or password.'
          };
          store.commit('addAlert', alert);
        } else {
          const alert = {
            alertGroup: 'login',
            status: 'error',
            message: 'Error logging in:',
            error
          };
          store.commit('addAlert', alert);
        }
        return false;
      });
  },
  resetPassword: function (store, username) {
    store.commit('clearAlerts', 'login');
    return axios.post(BASE_URL + '/ClientForgotPassword/' + username)
      .then(response => {
        const alert = {
          alertGroup: 'login',
          status: 'success',
          message: 'You have successfully sent a reset password request. Please wait for the email.'
        };
        store.commit('addAlert', alert);
        return true;
      })
      .catch((error) => {
        const alert = {
          alertGroup: 'login',
          status: 'error',
          message: 'Error reseting password:',
          error
        };
        store.commit('addAlert', alert);
        return false;
      });
  },
  logout: function (store) {
    return new Promise((resolve, reject) => {
      store.commit('setUserObject', {});
      store.commit('setUserToken', null);
      store.dispatch('resetData');
      resolve();
    });
  },
  initializeAuth: function (store) {
    const token = Cookies.get('user-token');
    if (token) {
      store.commit('setUserToken', token);
    }
  },
  getOrganization: async function (store) {
    store.commit('setLoading', true);
    return axios.get(BASE_URL + '/Organization')
      .then(response => {
        store.commit('setProducts', response.data);
      })
      .catch((error) => {
        const alert = {
          alertGroup: 'products',
          status: 'error',
          message: 'Error retrieving data:',
          error
        };
        store.commit('addAlert', alert);
      })
      .finally((response) => {
        store.commit('setLoading', false);
        return response;
      });
  }
};

export const getters = {
  isAuthenticated: function (state) {
    return !!state.userToken;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
